import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  ElementRef,
  ViewChild,
} from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Subscription, take } from 'rxjs'
import { SquidexService } from '../../../services/squidex.service'
import { TransferStateService, isScullyGenerated } from '@scullyio/ng-lib'
import { SwiperOptions } from 'swiper/types'

@Component({
  selector: 'flowaccount-platform-businesses-connection',
  templateUrl: './platform-businesses-connection.component.html',
  styleUrl: './platform-businesses-connection.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PlatformBusinessesConnectionComponent implements OnInit, OnDestroy {
  @ViewChild('swiperComponent', { read: ElementRef }) swiperComponent: ElementRef
  public config: SwiperOptions
  public ConnectionService: Subscription
  public PaymentService: Subscription
  public ConnectionList: any
  public PaymentList: any
  public selectedTabType = 'ALL'
  public filteredConnections: any = []
  private CONNECTIONS_SERVICE_KEY = 'connections-service-key'
  private PAYMENT_SERVICE_KEY = 'payment-service-key'

  constructor(
    public translate: TranslateService,
    public readonly squidexService: SquidexService,
    protected tstate: TransferStateService,
    public cdref: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    // After scully is builded
    if (isScullyGenerated()) {
      this.tstate.useScullyTransferState(this.PAYMENT_SERVICE_KEY, this.PaymentList).subscribe((data: any) => {
        this.PaymentList = data
        this.cdref.markForCheck()
      })
      this.tstate.useScullyTransferState(this.CONNECTIONS_SERVICE_KEY, this.ConnectionList).subscribe((data: any) => {
        this.ConnectionList = data
        this.filterConnections()
        this.onClickSelectedTab(this.selectedTabType)
        this.cdref.markForCheck()
      })
    } else {
      this.getPaymentService()
      this.getConnectionService()
    }
    this.swiperConfig()
  }

  getPaymentService() {
    this.squidexService
      .getContentSquidexApiOrder('payments')
      .pipe(take(1))
      .subscribe((data: object[]) => {
        this.PaymentList = data
        this.tstate.setState(this.PAYMENT_SERVICE_KEY, data)
        this.cdref.markForCheck()
      })
  }

  getConnectionService() {
    this.squidexService
      .getContentSquidexApiOrder('platform-businesses')
      .pipe(take(1))
      .subscribe((data: object[]) => {
        this.ConnectionList = data
        this.filterConnections()
        this.onClickSelectedTab(this.selectedTabType)
        this.tstate.setState(this.CONNECTIONS_SERVICE_KEY, data)
        this.cdref.markForCheck()
      })
  }

  swiperConfig() {
    this.config = {
      observer: true,
      observeParents: true,
      watchOverflow: true,
      speed: 700,
      initialSlide: 0,
      keyboard: false,
      mousewheel: true,
      scrollbar: false,
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    }
  }

  filterConnections(): void {
    if (this.selectedTabType === 'ALL') {
      this.filteredConnections = this.ConnectionList
    } else {
      this.filteredConnections = this.ConnectionList.filter(
        (item) => item.data.tagName.iv.tagName === this.selectedTabType,
      )
    }
  }

  onClickSelectedTab(tabNameType: string) {
    this.selectedTabType = tabNameType
    this.filterConnections()
    this.swiperConfig()
    setTimeout(() => {
      this.swiperComponent.nativeElement.swiper.update()
    }, 0)
    this.cdref.markForCheck()
  }

  ngOnDestroy(): void {
    this.ConnectionService?.unsubscribe()
    this.PaymentService?.unsubscribe()
  }
}
